{% block stripe_settings_icon %}
    <svg
            width="24"
            height="24"
            viewBox="0 0 256 256"
            xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <linearGradient
                    id="linearGradient"
                    x1="100%"
                    y1="58.356%"
                    x2="0%"
                    y2="0%"
            >
                <stop
                        stop-color="#2697D4"
                        offset="0%"
                />
                <stop
                        stop-color="#207BCB"
                        offset="50%"
                />
                <stop
                        stop-color="#2285CE"
                        offset="100%"
                />
            </linearGradient>
        </defs>
        <path
                d="M24,0 L232,0 C245.254834,-2.4348735e-15 256,10.745166 256,24 L256,232 C256,245.254834 245.254834,256 232,256 L24,256 C10.745166,256 1.623249e-15,245.254834 0,232 L0,24 C-1.623249e-15,10.745166 10.745166,2.4348735e-15 24,0 Z"
                style="fill:url(#linearGradient); fill-rule:nonzero;"
        />
        <path
                d="M139.688,111 C126.761,106.22 119.677,102.5 119.677,96.657 C119.677,91.697 123.75,88.865 131.011,88.865 C144.292,88.865 157.927,94.001 167.313,98.604 L172.625,65.844 C165.187,62.302 149.958,56.459 128.885,56.459 C114.011,56.459 101.615,60.354 92.761,67.615 C83.551,75.229 78.771,86.209 78.771,99.49 C78.771,123.573 93.469,133.844 117.375,142.521 C132.781,148.011 137.917,151.907 137.917,157.927 C137.917,163.771 132.957,167.135 123.927,167.135 C112.77,167.135 94.355,161.646 82.312,154.563 L77,187.677 C87.27,193.521 106.395,199.541 126.23,199.541 C141.99,199.541 155.094,195.823 163.948,188.74 C173.864,180.948 179,169.438 179,154.563 C179,129.948 163.948,119.677 139.687,111.001 L139.688,111 Z"
                style="fill:#FFFFFF; fill-rule:evenodd;"
        />
    </svg>

{% endblock %}
